<template>
  <div :class="`formats__format formats__format--${slug}`">
    <div class="formats__icon">
      <template v-if="slug === 'filter-pack'">
        <iconFilterPack />
      </template>
      <template v-if="slug === 'fraction-pack'">
        <iconFractionPacks />
      </template>
      <template v-if="slug === 'roast-ground'">
        <iconRoastGround />
      </template>
      <template v-if="slug === 'select-brew'">
        <iconSelectBrew />
      </template>
      <template v-if="slug === 'whole-bean'">
        <iconWholeBean />
      </template>
    </div>
    <h2>{{ name }}</h2>
    <p v-html="copy"></p>
    <button type="button" v-html="linkText" @click="pickFormat(slug)" aria-controls="product-results"></button>
  </div>
</template>

<script>
import zenscroll from 'zenscroll'
import { assetPath } from './../../mixins/assetPath.js'
import iconFilterPack from '@/assets/icons/FormatIcons_FilterPack.svg'
import iconFractionPacks from '@/assets/icons/FormatIcons_FractionPacks.svg'
import iconRoastGround from '@/assets/icons/FormatIcons_RoastGround.svg'
import iconSelectBrew from '@/assets/icons/FormatIcons_SelectBrew.svg'
import iconWholeBean from '@/assets/icons/FormatIcons_WholeBean.svg'

export default {
  name: 'Format',
  components: {
    iconFilterPack,
    iconFractionPacks,
    iconRoastGround,
    iconSelectBrew,
    iconWholeBean,
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    },
    copy: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: `Learn More`
    },
  },
  methods: {
    pickFormat(format) {
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Format Choice | ' + format,
        });
      }
      this.$store.dispatch('pickFormat', format)
      // this.$emit('formatSelected', format)
      setTimeout(() => zenscroll.to(document.getElementById('products-wrapper')), 500)
    }
  },
  mixins: [assetPath]
}
</script>

<style lang="scss">
  .formats__format {
    flex: 1 1 auto;
    text-align: center;
    background-color: white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 1.5em 1em 2em 1em;
    p {
      color: $lgrayer;
      max-width: 32em;
      margin-left: auto;
      margin-right: auto;
      flex: 1 1 auto;
    }
    h2 {
      font-size: 18px;
      font-weight: 900;
      text-transform: uppercase;
      line-height: 1;
      color: $lgrayer;
      margin: 0.25em auto 0.5em auto;
    }
    button {
      padding: 0;
      background-color: transparent;
      color: $green;
      font-family: $serif;
      text-decoration: underline;
      font-size: 14px;
      &:hover {
        color: $green-hover;
      }
    }
  }
  
  .formats__icon {
    width: 75px;
    // margin-bottom: 0.25em;
    margin-bottom: 0.5em;
  }
  .formats__format--select-brew {
    .formats__icon {
      width: 135px;
      // margin-bottom: 0.75em;
    }
  }
</style>